/* Program Name: AppSwitch.js
 **  Description: a component that will Switch the content on the screen, using
 **               react-router and the URL
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-03-17  STT  Initial program
 ** SD9567     2026-02-02  SGS  ITSM-517 - Expose CC Expiration Dates for Call Center
 *********************************************************************************/

/**React imports */
import React, { lazy, Suspense } from 'react'

/**React Router imports */
import { Switch, Route } from 'react-router-dom'

/**Custom Component imports */
import ProtectedRoute from './Components/Common/Routes/ProtectedRoute'
import Login from './Components/Common/Login/Login'
import PageNotFound from './Components/Common/404/PageNotFound'
import LoadingModal from './Components/Common/Loading/LoadingModal'
import GeneralLayout from './Components/Common/Layout/GeneralLayout'
import Forgotpassword from './Components/Common/Login/Forgotpassword'

/**Lazy loading components */
const Home = lazy(() => import('./Components/Home/HomeLayout'))
const Shop = lazy(() => import('./Components/Shop/Shop'))
const MaintSwitch = lazy(() => import('./Components/Maint/MaintSwitch'))
const ReportsSwitch = lazy(() => import('./Components/Reports/ReportsSwitch'))
const Cart = lazy(() => import('./Components/Cart/Cart'))
const Promotions = lazy(() => import('./Components/Promo/Promotions'))
const MyAccount = lazy(() => import('./Components/Account/MyAccount'))
const Checkout = lazy(() => import('./Components/Cart/Checkout'))
/* const StoreMaint = lazy(() => import("./Components/StoreProfiles/StoreMaint"));
const StoreProfile = lazy(() => import("./Components/StoreProfiles/StoreProfile")); */
const Orders = lazy(() => import('./Components/Orders/OrderMaint'))
const PromoBuilder = lazy(() => import('./Components/Promo/PromoSwitch'))
const PromoDetails = lazy(() => import('./Components/Home/PromoDetails'))
const PNPSuccess = lazy(() => import('./Components/Common/PNPSuccess'))
const LocMassUpload = lazy(() =>
  import('./Components/StoreProfiles/MassUpload')
)
const MyCarts = lazy(() => import('./Components/Cart/MyCarts'))
const CartErrors = lazy(() => import('./Components/Cart/CartErrors'))

/**AppSwitch ******************************************************************/

const AppSwitch = () => {
  /******************************************************************************/
  /**Rendering */

  return (
    <GeneralLayout>
      <Suspense fallback={<LoadingModal />}>
        <Switch>
          <Route exact path="/login">
            <Login />
          </Route>
          <Route exact path="/forgotpassword">
            <Forgotpassword />
          </Route>
          <ProtectedRoute exact path="/" component={Home} title={'Home'} />
          <ProtectedRoute exact path="/Shop" component={Shop} title={'Shop'} />
          <ProtectedRoute exact path="/Cart" component={Cart} title={'Cart'} />
          <ProtectedRoute
            exact
            path="/CartErrors/:id/:origin"
            component={CartErrors}
            title={'Cart Errors'}
          />
          <ProtectedRoute
            exact
            path="/Checkout"
            component={Checkout}
            title={'Check Out'}
          />
          <ProtectedRoute
            path="/Maint"
            component={MaintSwitch}
            title={'Maintenance'}
          />
          <ProtectedRoute
            path="/Report"
            component={ReportsSwitch}
            title={'Reports'}
          />
          <ProtectedRoute
            exact
            path="/pnpsuccess"
            component={PNPSuccess}
            title={'Success'}
          />
          <ProtectedRoute
            exact
            path="/promotions"
            component={Promotions}
            title={'Promotion'}
          />
          <ProtectedRoute
            path="/promobuilder"
            component={PromoBuilder}
            title={'Promo Builder'}
          />
          <ProtectedRoute
            path="/account"
            component={MyAccount}
            title={'Account'}
          />
          <ProtectedRoute
            path="/profilemassupload"
            component={LocMassUpload}
            title={'Mass Upload'}
          />
          {/* <ProtectedRoute exact path='/stores'             component={StoreMaint}/>
              <ProtectedRoute exact path='/store'              component={StoreProfile}/> */}
          <ProtectedRoute
            exact
            path="/orders"
            component={Orders}
            title={'Orders'}
          />
          <ProtectedRoute
            exact
            path="/promodetails/:loc/:id"
            component={PromoDetails}
            title={'Promo Details'}
          />
          <ProtectedRoute
            exact
            path="/mycarts"
            component={MyCarts}
            title={'My Carts'}
          />
          <Route component={PageNotFound} />
        </Switch>
      </Suspense>
    </GeneralLayout>
  )
}

export default AppSwitch
